import environment from '@/modules/cart/environments/environment';
import httpClient from '@/modules/cart/services/api/client';
import type { shippingMethodBodyRequest } from '@/modules/shippingMethod/domain/ShippingMethodRepository';

import type { HttpShippingMethodDto } from '../../dto/HttpShippingMethodDto';

const { CART_URL } = environment;

export const getGeneralShippingMethods = async (
  params?: shippingMethodBodyRequest[]
): Promise<{
  data: HttpShippingMethodDto;
}> => {
  return await httpClient.post(`${CART_URL}/shipping-methods-grouping`, {
    lineItems: params ?? []
  });
};
